import type {
  StateSearchReplicaFilters,
  ReplicasValues,
} from '~/types/search/types'

export const useSearchReplicaFilters = () => {
  const stateSearchReplicaFilters = useState<StateSearchReplicaFilters>(
    'state-search-replica-filter',
  )

  const { t } = useI18n({ useScope: 'global' })

  const currentReplica = computed(
    () => stateSearchReplicaFilters.value.currentReplica,
  )
  const replicas = computed(() => stateSearchReplicaFilters.value.replicas)
  const replicasFormatted = computed(() =>
    replicas.value.map((replica) => ({
      label: t(`search.${replica.label}`),
      value: replica.value,
    })),
  )

  const setReplicaFilters = (newReplica: {
    label: ReplicasValues
    value: string
  }) => {
    stateSearchReplicaFilters.value.currentReplica = newReplica
  }

  return {
    currentReplica,
    replicas,
    replicasFormatted,
    setReplicaFilters,
  }
}
